import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { KeyPortMessage } from '../../types/KeyPortMessage';
import type { KeyPortRequestMessage } from '../../types/KeyPortRequestMessage';
import type { ValidationResponse } from '../../types/ValidationResponse';
import { createKeyPort } from '../common/api/clients/keyPorts.api';
import { queries } from '../common/api/queryKeys/queries';

export const useKeyPortCreate = () => {
    const queryClient = useQueryClient();

    return useMutation<KeyPortMessage, AxiosError<ValidationResponse>, KeyPortRequestMessage>({
        mutationFn: createKeyPort,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.keyPorts._def });
        },
    });
};
